export default __webpack_public_path__ + "static/media/roadtrip_responsive.4a8aaab9.png";